export const serializeFormData = (
  formData: FormData,
  addressData?: { city?: string; state?: string }
): Record<string, any> => {
  const data: Record<string, any> = {};

  formData.forEach((value, key) => {
    if (key.endsWith('[]')) {
      const newKey = key.slice(0, -2);
      if (!data[newKey]) {
        data[newKey] = [];
      }
      data[newKey].push(value);
    } else {
      data[key] = value;
    }
  });

  if (addressData?.city && addressData?.state) {
    data["city"] = addressData.city;
    data["state"] = addressData.state;
  }

  return data;
};
